import { render, staticRenderFns } from "./VirtualAssistantEventsDetailsTable.vue?vue&type=template&id=401cb24c&scoped=true&"
import script from "./VirtualAssistantEventsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./VirtualAssistantEventsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAssistantEventsDetailsTable.vue?vue&type=style&index=0&id=401cb24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cb24c",
  null
  
)

export default component.exports